import { Row, Col, Typography, Button, Tooltip } from 'antd';
import { PieChartOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import MoneyDisplay from "./MoneyDisplay";
import utils from './utils';

const { Text } = Typography;

const titleRowStyle = { display: 'flex', alignItems: 'center', gap: 4 };

// Jump from a headline figure to the insights page that breaks it down, carrying
// the current filters along in the hash so the two views agree.
const ExploreLink = ({ to, tooltip }) => (
  <Tooltip title={tooltip}>
    <Link to={{ pathname: to, hash: utils.getUpdatedURL() }}>
      <Button size="small" type="text" icon={<PieChartOutlined />} />
    </Link>
  </Tooltip>
);

const boxStyle = {
    marginBottom: '25px'
};

const colStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center' };

const IntentAggregations = (props) => {
  const income = Number(props.data?.income_sum?.total_amount ?? 0);
  const expense = Number(props.data?.expense_sum?.total_amount ?? 0);
  const diff = income - expense;
  const profitability = income > 0 ? (diff / income) * 100 : null;

  let profitabilityContent;
  let profitabilityColor;
  if (profitability === null) {
    profitabilityContent = '—';
    profitabilityColor = 'grey';
  } else {
    const sign = profitability > 0 ? '+ ' : profitability < 0 ? '- ' : '';
    profitabilityContent = `${sign}${Math.abs(profitability).toFixed(1)} %`;
    profitabilityColor = profitability > 0 ? 'green' : profitability < 0 ? 'red' : 'grey';
  }

  return (
    <Row style={boxStyle} justify="space-around" align="top">
      <Col flex="1" style={colStyle}>
        <span style={titleRowStyle}>
          <Text><b>{props.expensesTitleOverride || 'ODHODKI'}</b></Text>
          {props.showExploreLinks && (
            <ExploreLink to="/insights/expenses" tooltip="Razčleni odhodke" />
          )}
        </span>
        <MoneyDisplay size='big' type='EXPENSE' val={props.data?.expense_sum?.total_amount} />
      </Col>
      <Col flex="1" style={colStyle}>
        <span style={titleRowStyle}>
          <Text><b>{props.incomesTitleOverride || 'PRIHODKI'}</b></Text>
          {props.showExploreLinks && (
            <ExploreLink to="/insights/incomes" tooltip="Razčleni prihodke" />
          )}
        </span>
        <MoneyDisplay size='big' type='INCOME' val={props.data?.income_sum?.total_amount} />
      </Col>
      <Col flex="1" style={colStyle}>
        <span style={titleRowStyle}>
          <Text><b>RAZLIKA</b></Text>
          {props.showExploreLinks && (
            <ExploreLink
              to="/insights/income_expense"
              tooltip="Primerjaj prihodke in odhodke"
            />
          )}
        </span>
        <MoneyDisplay size='big' type='TAX' val={diff} />
      </Col>
      <Col flex="1" style={colStyle}>
        <Text><b>PROFITABILNOST</b></Text>
        <Text style={{ color: profitabilityColor, fontSize: '30px', fontWeight: 1000 }}>
          {profitabilityContent}
        </Text>
      </Col>
      {props.showAllTypes && (
        // Every type, signed -- transfers and tax included (backend all_sum).
        <Col flex="1" style={colStyle}>
          <Text><b>VSE TRANSAKCIJE</b></Text>
          <MoneyDisplay size='big' type='TAX' val={Number(props.data?.all_sum?.total_amount ?? 0)} />
        </Col>
      )}
    </Row>
  );
};

export default IntentAggregations;
